/**
 *
 * this class is in charge of offering to upsell offers
 *
 * */
import * as bundleHelper from './helpers/bundle';
import {Bundle} from "./bundle";
import {Emitter} from "./emitter";
const BASE_URL_IMAGE = ABV4_SETTINGS.base_url_image,
    IMAGE_VERSION = ABV4_SETTINGS.images_version,
    UPSELL_HEADING = ABV4_SETTINGS.bundle.upsell_bundle_heading;

export class UpsellBundle {
    constructor(addedBundle, api, cart, popup) {
        this.addedBundleItems = addedBundle.data;
        this.addedBundleClass = addedBundle.bundle_class;
        this.cart = cart;
        this.api = api;
        this.popup = popup;
        this.bundlesArray = bundles_array;
        this.bundleUpsell = bundle_upsell;

        this.canUpsell = this.canUpsell.bind(this);
        this.getBundles = this.getBundles.bind(this);
        this.removeBundleFromCart = this.removeBundleFromCart.bind(this);
        this.handleCTAupsell = this.handleCTAupsell.bind(this);
        const canUpsell = this.canUpsell();
        if (!canUpsell)
            return false;

        this.upsellBundles = this.getBundles();

        if (this.upsellBundles.length > 0)
            this.renderBundleTile();
    }

    /**
     *
     * check if added bundle contain upsell bundle
     * @return boolean
     *
     * */
    canUpsell() {
        const { bundleUpsell, addedBundleClass } = this,
            checkUpsell = bundleUpsell[addedBundleClass];
        if (typeof checkUpsell !== 'undefined')
            return true;
        else
            return false;
    }

    /**
     * bundles to be displayed on the page
     * @return array
     * */
    getBundles() {
        const { bundlesArray, bundleUpsell, addedBundleClass } = this;
        let bundles = [];
        for (const bundleForUpsell of bundleUpsell[addedBundleClass]) {
            for (const bundle of bundlesArray) {
                if (bundle.bundle_class === bundleForUpsell) {
                    const soldOut = bundleHelper.available(bundle);
                    if (!soldOut) {
                        bundles.push(bundle);
                        break;
                    }
                }
            }
        }

        return bundles;
    }

    /**
     *
     * render bundles on the page
     * @return void
     *
     * */

    renderBundleTile() {
        const { upsellBundles } = this,
            popupContainer = $('.v4-add-to-cart-popup');
        let htmlFrame = '';
        for (const bundle of upsellBundles) {
            const prices = bundleHelper.getBundlePrice(bundle);
            htmlFrame += `<div class="cart-bundle-wrapper col-md-6 col-lg-4">
                <div class="cart-bundle-image">
                <img class="img-fluid object-fit-contain lazyload "
                    alt="Ashley Black Experience - '${bundle.bundle_name} "
                    data-expand="-20"
                    data-src="${BASE_URL_IMAGE}cart_bundle_${bundle.bundle_class}_{width}x.jpg?v=${IMAGE_VERSION}"
                    data-master-src="${BASE_URL_IMAGE}cart_bundle_${bundle.bundle_class}.jpg?v=${IMAGE_VERSION}"
                    data-sizes="auto"
                    src="data:image/png;base64,R0lGODlhAQABAAD/ACwAAAAAAQABAAACADs=">
                </div>
                <p class="cart-bundle-title">${bundle.bundle_name}</p>
                <div class="upsell-bundle-price"><span class="bundle_original_price">${prices[1]}</span><span
                        class="bundle_discunted_price">${prices[0]}</span></div>
                <button class="btn-buynow-bundle" data-bundle="${bundle.bundle_class}">
                    Add To Cart
                </button>
            </div>`
        }
        popupContainer.find('.v5-bundle-upsell-popup-heading').text(UPSELL_HEADING);
        popupContainer.find('.v5-bundle-upsell-placeholder-collection').html(htmlFrame);

       const bundleButtons =  popupContainer.find('.v5-bundle-upsell-placeholder-collection .btn-buynow-bundle');
       this.handleCTAupsell(bundleButtons);
    }

    /**
     * trigger for adding upsell to cart
     * @return void
     * */
    handleCTAupsell(buttons) {
        for(let i = 0; i < buttons.length; i++) {
            const button = $(buttons[i]);
            button.on('click', () => {
                $('.v4-add-to-cart-popup').find('.v5-bundle-upsell-popup-heading').text(' ');
                $('.v4-add-to-cart-popup').find('.v5-bundle-upsell-placeholder-collection').html(' ');
            });
            new Bundle(this.api, this.popup, button, 'upsell')
                .on('bundleDelete', this.removeBundleFromCart);
        }
    }

    /**
     *
     * remove bundle from cart
     * add new bundle to cart
     *
     * @return void
     * */
    removeBundleFromCart(e, value) {
        const { addedBundleClass, cart } = this;
        cart.getData().then((cart) => {
            const cartItems = cart.items;
            let data = { updates: {} }
            for(const [index, item] of cartItems.entries()) {
                if(item.properties.hasOwnProperty('bundle')) {
                    if(addedBundleClass === item.properties.bundle_class) {
                        data.updates[item.key] = 0;
                    }
                }
            }

            this.api.cartUpdate(data).then((res) => {
                this.popup.handleBundleSubmitted(value, 'upsell')
            });
        });
    }
}